import { Link } from 'react-router-dom';
import { useInView } from '../../../hooks/useInView';

const PUNTOS = [
  { icon: 'ri-lightbulb-line', label: 'Luces delanteras y traseras' },
  { icon: 'ri-lightbulb-flash-line', label: 'Intermitentes y emergencias' },
  { icon: 'ri-drop-line', label: 'Nivel de aceite de motor' },
  { icon: 'ri-thermometer-line', label: 'Nivel de refrigerante' },
  { icon: 'ri-stop-circle-line', label: 'Nivel de líquido de frenos' },
  { icon: 'ri-water-flash-line', label: 'Nivel de dirección asistida' },
  { icon: 'ri-contrast-drop-line', label: 'Nivel de limpiaparabrisas' },
  { icon: 'ri-stop-circle-fill', label: 'Frenos delanteros' },
  { icon: 'ri-stop-circle-fill', label: 'Frenos traseros y discos' },
  { icon: 'ri-arrow-up-down-line', label: 'Amortiguadores' },
  { icon: 'ri-car-line', label: 'Suspensión delantera' },
  { icon: 'ri-car-line', label: 'Suspensión trasera' },
  { icon: 'ri-shape-line', label: 'Silentblocks y rótulas' },
  { icon: 'ri-loop-right-line', label: 'Correa de distribución' },
  { icon: 'ri-settings-3-line', label: 'Estado del embrague' },
  { icon: 'ri-donut-chart-line', label: 'Neumáticos — desgaste' },
  { icon: 'ri-radar-line', label: 'Presión de neumáticos' },
  { icon: 'ri-battery-2-charge-line', label: 'Batería y alternador' },
  { icon: 'ri-wind-line', label: 'Sistema de escape' },
  { icon: 'ri-road-map-line', label: 'Bajo del vehículo' },
  { icon: 'ri-steering-2-line', label: 'Dirección y alineación' },
  { icon: 'ri-eye-line', label: 'Limpiaparabrisas' },
  { icon: 'ri-speed-up-line', label: 'Transmisión y juntas' },
  { icon: 'ri-cpu-line', label: 'Testigos del cuadro' },
  { icon: 'ri-shield-check-line', label: 'Estado general del vehículo' },
];

const InspeccionGratisSection = () => {
  const [badgeRef, badgeInView] = useInView(0.1);
  const [listRef, listInView] = useInView(0.05);
  const [imgRef, imgInView] = useInView(0.1);

  return (
    <section className="bg-zinc-950 overflow-hidden relative">
      {/* Top accent line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-yellow-400/40 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 py-20 lg:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">

          {/* LEFT — image */}
          <div
            ref={imgRef}
            className={`order-2 lg:order-1 relative transition-all duration-700 ${
              imgInView ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'
            }`}
          >
            <div className="relative overflow-hidden border border-zinc-800">
              <img
                src="https://public.readdy.ai/ai/img_res/5d05c3d10212eb70dd03994fd3a72498.jpg"
                alt="Revisión de 25 puntos gratuita"
                className="w-full h-[480px] lg:h-[580px] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />

              {/* Floating badge */}
              <div className="absolute top-5 left-5 bg-yellow-400 text-black px-4 py-2.5">
                <p className="text-[10px] font-bold uppercase tracking-[0.2em] leading-none">Solo por visitarnos</p>
                <p className="text-2xl font-black leading-tight mt-0.5 tracking-tight">100% GRATIS</p>
              </div>

              {/* Bottom label */}
              <div className="absolute bottom-5 left-5 right-5">
                <p className="text-white text-xs uppercase tracking-[0.2em] font-bold mb-1 text-zinc-400">Revisión completa</p>
                <p className="text-white font-black text-2xl uppercase tracking-wide leading-tight">
                  25 Puntos de Inspección
                </p>
              </div>
            </div>

            {/* Decorative yellow corner */}
            <div className="absolute -bottom-4 -right-4 w-24 h-24 border-r-2 border-b-2 border-yellow-400/30 hidden lg:block" />
            <div className="absolute -top-4 -left-4 w-14 h-14 border-l-2 border-t-2 border-yellow-400/20 hidden lg:block" />
          </div>

          {/* RIGHT — content */}
          <div className="order-1 lg:order-2">
            <div
              ref={badgeRef}
              className={`transition-all duration-700 ${
                badgeInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
              }`}
            >
              <div className="inline-flex items-center gap-2 mb-4">
                <span className="w-5 h-px bg-yellow-400" />
                <span className="text-yellow-400 text-[10px] font-bold uppercase tracking-[0.3em]">
                  Sin compromiso · Completamente gratuita
                </span>
              </div>

              <h2 className="font-display text-4xl md:text-5xl xl:text-6xl uppercase text-white leading-none tracking-wide mb-2">
                Revisión de
              </h2>
              <h2 className="font-display text-4xl md:text-5xl xl:text-6xl uppercase leading-none tracking-wide mb-5">
                <span className="text-yellow-400">25 puntos</span>
                <span className="text-white"> gratis</span>
              </h2>

              <p className="text-zinc-400 text-sm leading-relaxed mb-8 max-w-md font-light">
                Solo por visitar nuestras instalaciones te hacemos una revisión completa de <strong className="text-zinc-200">25 puntos clave</strong> del vehículo: luces, niveles, frenos, suspensión, correa, embrague, silentblocks y mucho más. Sin cita previa. Sin coste.
              </p>
            </div>

            {/* Points grid */}
            <div
              ref={listRef}
              className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 mb-9"
            >
              {PUNTOS.map((punto, idx) => (
                <div
                  key={punto.label}
                  className={`flex items-center gap-2.5 transition-all duration-500 ${
                    listInView ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'
                  }`}
                  style={{ transitionDelay: `${idx * 0.04}s` }}
                >
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-checkbox-circle-fill text-yellow-400 text-base" />
                  </div>
                  <span className="text-zinc-400 text-xs font-light leading-tight">{punto.label}</span>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <Link
                to="/contacto"
                className="inline-flex items-center gap-3 bg-yellow-400 text-black px-7 py-3.5 font-bold text-xs uppercase tracking-widest hover:bg-yellow-300 transition-colors cursor-pointer whitespace-nowrap group"
              >
                Visítanos ahora
                <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform" />
              </Link>
              <a
                href="tel:+34666365922"
                className="inline-flex items-center gap-2 text-zinc-400 hover:text-yellow-400 text-xs font-bold uppercase tracking-widest transition-colors cursor-pointer whitespace-nowrap"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-sm" />
                </div>
                +34 666 36 59 22
              </a>
            </div>
          </div>

        </div>
      </div>

      {/* Bottom accent */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-yellow-400/20 to-transparent" />
    </section>
  );
};

export default InspeccionGratisSection;
